export default class Category {
  constructor() {
    this._items = [
      {value: 0, label: 'Кассовый'},
      {value: 1, label: 'Безналичный'},
      {value: 2, label: 'Бонусный'},
    ];
    this._loading = false;
  }

  get(){
    const self = this;
    return new Promise((resolve, reject) => {
      self.set();
      resolve(self);
    });
  }
  set(data){
    this._items = [
      {value: 0, label: 'Кассовый'},
      {value: 1, label: 'Безналичный'},
      {value: 2, label: 'Бонусный'},
    ];
  }
  get loading() {
    return this._loading;
  }

  set loading(value) {
    this._loading = value;
  }

  get items() {
    return this._items;
  }
}